import { Component, OnInit } from '@angular/core';


import { ActivatedRoute, Router } from '@angular/router';
import { AdminService } from '../../services/admin.service';
import { HomeDetails } from '../../models/home.details.interface';
import { AdminSetup } from '../../models/admin.setup.interface';
import { HttpErrorResponse } from '@angular/common/http';
import { RolePermission } from '../../../shared/models/role.permission.enum';

@Component({
  selector: 'app-dealer-home',
  templateUrl: './dealer-home.component.html',
  styleUrls: ['./dealer-home.component.scss']
})
export class DealerHomeComponent implements OnInit {
  pageTitle: string = "Admin";
  homeDetails: HomeDetails;
  adminSetup: AdminSetup;
  needPMSetup: number;
  errors: string = '';

  isIDIAdmin: boolean;

  constructor(private adminService: AdminService, private route: ActivatedRoute, private router: Router) { }

  ngOnInit() {
    this.isIDIAdmin = (AdminService._authNavStatusSource.value == 'IDI');
    let isAdmin = AdminService.hasPermission(RolePermission.Admin);

    if (!isAdmin) this.router.navigate(['/']);

    this.adminService.getHomeDetails()
      .subscribe({
        next: (homeDetails: HomeDetails) => {
          this.homeDetails = homeDetails;
        },
        error: () => {
          //this.notificationService.printErrorMessage(error);
        }
      });

    this.adminService.checkDealerSetup()
      .subscribe({
        next: (result) => {
          this.adminSetup = result;
          this.needPMSetup = result.projectManagementSetupAreas.length
        },
        error: (error: string) => {
          this.errors = error;
        }
      });
  }

  businessManagement() {
    //do your any operations
    this.router.navigate(['/admin/business']);
  }

  projectManagement() {
    //do your any operations
    this.router.navigate(['/admin/project']);
  }

}
